import { Box } from "@mui/system";
import React, { Component } from "react";
import MUISwitch from "../components/ui-components/toggleSwitch";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Button, Divider } from "@mui/material";

import Progress from "../components/ui-components/graphs/Progress";
import PieGraph from "../components/ui-components/graphs/PieGraph";

import { getURLBase } from "../utils/helperFns";
import axios from "axios";
import wyzrTheme from "../styles/customTheme";
import { ChevronRightRounded } from "@mui/icons-material";
import { Link } from "react-router-dom";

export class UpcomingMonthlySpends extends Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/upcomingmonthlyspend";
    this.state = {
      isReady: false,
      tutorial_iframe: ""  // tutorial_iframe is not coming from api. ASK API team to add this field in response
    };
  }
  componentDidMount() {
    axios.post(this.url, { gid: this.props.gid }).then((response) => {
      this.setState(response.data.body);
      this.setState({
        tutorial_iframe: response.data.body.tutorial_iframe,
        isReady: true,
      });


      if (this.state.currentViewisMoney) {
        this.processData(this.state.data.moneyTab.pieData);
      } else {
        this.processData(this.state.data.footprintTab.pieData);
      }
    });
  }
  handleChange = () => {
    this.setState({
      currentViewisMoney: !this.state.currentViewisMoney,
    });
    if (!this.state.currentViewisMoney) {
      this.processData(this.state.data.moneyTab.pieData);
    } else {
      this.processData(this.state.data.footprintTab.pieData);
    }
  };

  toggleTransactionScreen = () => {
    var transactionShown = this.state.showAllTransaction;
    transactionShown = !transactionShown;
    this.setState({ showAllTransaction: transactionShown });
  };

  processData = (response) => {
    let moreData = response;
    response = response.processData;
    let textdata = response.text;
    let piedata = [];

    let d = new Map(Object.entries(response.debit));
    let c = new Map(Object.entries(response.credit));
    let total = 0;

    for (const [k, v] of c.entries()) {
      piedata.push({ name: k, value: v });
      total += v;
    }

    for (const [k, v] of d.entries()) {
      piedata.push({ name: k, value: v });
      total += v;
    }
    this.setState({
      piedata: piedata,
      textdata: textdata,
      total: Math.round(total * 100) / 100,
      moreData: moreData,
    });
  };

  render() {
    const WidgetData = () => (
      <Card className={"widgetCard cardShadow "}>
        {/* className={ `${this.state.total > 0 ? "widgetCard cardShadow blur" : "widgetCard cardShadow"  }`  } */}
        {this.state.isReady ? (
          <>
            <Typography variant="h4" sx={{ fontWeight: 700 }} align="center" mx={"auto"} width="65%">
              {this.state.currentViewisMoney
                ? "Upcoming Monthly Spends"
                : this.state.data.footprintTab.tabHeading}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              fontWeight="600"
              align="center"
              gutterBottom
            >
              {this.state.currentViewisMoney
                ? this.state.data.moneyTab.subHeading
                : this.state.data.footprintTab.subHeading}
            </Typography>
            <Button sx={{
              margin: "0 auto",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							marginY: "0.5rem",
							marginTop: "-0.5rem",
							// fontSize: "0.7rem",
							padding: "2px"
            }}
              onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
            >
              See how this works <img src="/tutorial-icon.png" style={{ width: "35px", padding: "5px" }} />
            </Button>
            <Divider light />

            <CardContent textAlign="center" pt={0} className={`${this.state.isReady ? (`${this.state.currentViewisMoney ? (`${(this.state.data.moneyTab.pieData.total === null || this.state.data.moneyTab.pieData.total === 0) ? "blur" : ""}`) : (`${(this.state.data.footprintTab.pieData.total === null || this.state.data.footprintTab.pieData.total === 0) ? "blur" : ""}`)}`) : ""}`}>
              <Box>
                <PieGraph
                  total={this.state.total}
                  piedata={this.state.piedata}
                  moreData={this.state.moreData}
                  colors={["#eee", "#e96e66"]}
                />

                {this.state.currentViewisMoney ? (
                  <Progress
                    width={{ xs: "100%", md: "50%" }}
                    prefix=' '
                    startText={
                      this.state.data.moneyTab.progressData.startText
                    }
                    endText={this.state.data.moneyTab.progressData.endText}
                    startNumber={
                      this.state.data.moneyTab.progressData.startNumber
                    }
                    endNumber={
                      this.state.data.moneyTab.progressData.endNumber
                    }
                    color={
                      this.state.data.moneyTab.progressData.color ===
                        "error" &&
                        this.state.data.moneyTab.progressData.subcolor ===
                        "light"
                        ? wyzrTheme.palette.error.light
                        : this.state.data.moneyTab.progressData.color ===
                          "primary" &&
                          this.state.data.moneyTab.progressData.subcolor ===
                          "light"
                          ? wyzrTheme.palette.primary.light
                          : ""
                    }
                    subcolor={this.state.data.moneyTab.progressData.subcolor}
                  />
                ) : (
                  <Progress
                    width={{ xs: "100%", md: "50%" }}
                    prefix=' '
                    startText={
                      this.state.data.footprintTab.progressData.startText
                    }
                    endText={
                      this.state.data.footprintTab.progressData.endText
                    }
                    startNumber={
                      this.state.data.footprintTab.progressData.startNumber
                    }
                    endNumber={
                      this.state.data.footprintTab.progressData.endNumber
                    }
                    color={
                      this.state.data.moneyTab.progressData.color ===
                        "error" &&
                        this.state.data.moneyTab.progressData.subcolor ===
                        "light"
                        ? wyzrTheme.palette.error.light
                        : this.state.data.moneyTab.progressData.color ===
                          "primary" &&
                          this.state.data.moneyTab.progressData.subcolor ===
                          "light"
                          ? wyzrTheme.palette.primary.light
                          : ""
                    }
                    subcolor={
                      this.state.data.footprintTab.progressData.subcolor
                    }
                  />
                )}
              </Box>
              <Box textAlign="center">
                <Button
                  sx={{ mx: "auto", mt: 3 }}
                  component={Link}
                  variant="outlined"
                  endIcon={<ChevronRightRounded />}
                  to={`${this.state.currentViewisMoney ? `${(this.state.data.moneyTab.pieData.total === null || this.state.data.moneyTab.pieData.total === 0) ? "/home" : "/spending/budget"}` : `${(this.state.data.footprintTab.pieData.total === null || this.state.data.footprintTab.pieData.total === 0) ? "/home" : "/spending/budget"}`}`}
                >
                  Your personalised budget
                </Button>

              </Box>
            </CardContent>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "20vh",
            }}
          >
            <CircularProgress color="success" />
          </Box>
        )}
      </Card>
    );

    return (
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
          <MUISwitch handleClick={this.handleChange} />
        </Box>
        <WidgetData />
      </Box>
    );
  }
}

export default UpcomingMonthlySpends;
